import { createReducer } from "actionware";
import { createState } from "stateware";
import { message } from "antd";
import _ from "lodash";

import {
  getFundingCycle,
  getLendersList,
  getProductsList,
  toggleBannerView,
  persistEditCurrentCycleData,
  persistNewCycleData,
  resetToInitialState,
  saveNewCycleData,
  setCurrentViewPage,
  toggleErrorCard,
} from "./fundingLimitActions";
import { getUpdatedStateData } from "./utils";

const defaultProductObject = {
  code: "",
  product_limit_snapshot: -1,
  lenders: {},
};

const defaultErrorCard = {
  errorCardVisible: false,
  errorApi: "",
  errorMessage: "",
};

const initialState = createState({
  showLenderRankingView: false,
  showNewCycleView: false,
  action: "newCycle",
  products: [],
  lenders: [],
  fundingCycle: {},
  newCycle: {},
  scheduleDate: null,
  timelineSteps: [],
  errorCard: defaultErrorCard,
  bannerDetails: {
    isBannerVisible: false,
    bannerTitle: "",
    isErrorBanner: false,
  },
});

export default createReducer(initialState)
  .on(getFundingCycle, (state, fundingCycle) => {
    return initialState.copy({
      ...state,
      fundingCycle,
    });
  })
  .onError(getFundingCycle, (state, error) => {
    return initialState.copy({
      ...state,
      showLenderRankingView: false,
      showNewCycleView: false,
      errorCard: {
        errorCardVisible: true,
        errorApi: "getFundingCycle",
        errorMessage: error,
      },
    });
  })

  .on(getProductsList, (state, products) => {
    let newCycle = {};
    products.map((product) => {
      product.product_name = product.name;
      return (newCycle[product.code] = {
        ...defaultProductObject,
        ...product,
      });
    });
    return initialState.copy({ ...state, products, newCycle: newCycle });
  })
  .onError(getProductsList, (state, error) => {
    message.error("Fetching new products failed", error, 10);
    initialState.copy({
      errorMessage: "Fetching new products failed",
      ...state,
      showLenderRankingView: false,
      showNewCycleView: false,
    });
  })

  .on(getLendersList, (state, lenders) => {
    return initialState.copy({ ...state, lenders });
  })
  .onError(getLendersList, (state, error) => {
    message.error("Fetching new lenders failed", error, 10);
    initialState.copy({
      errorMessage: "Fetching new lenders failed",
      ...state,
      showLenderRankingView: false,
      showNewCycleView: false,
    });
  })

  .on(saveNewCycleData, (state, data) => {
    const newCycle = getUpdatedStateData(state, data);
    return initialState.copy({ ...state, newCycle });
  })

  .on(persistNewCycleData, (state) => {
    return initialState.copy({
      ...state,
    });
  })

  .on(persistEditCurrentCycleData, (state) => {
    return initialState.copy({
      ...state,
    });
  })

  .on(setCurrentViewPage, (state, data) => {
    return initialState.copy({
      ...state,
      ...data,
    });
  })

  .on(resetToInitialState, (state, data) => {
    return initialState.copy({
      ...state,
      products: [],
      lenders: [],
      fundingCycle: {},
      newCycle: {},
      timelineSteps: [],
      showLenderRankingView: false,
      showNewCycleView: false,
      errorCard: defaultErrorCard,
    });
  })

  .on(toggleBannerView, (state, data) => {
    return initialState.copy({
      ...state,
      bannerDetails: {
        isBannerVisible: data.showFlag,
        bannerTitle: data.title,
        isErrorBanner: data.isError,
      },
    });
  })

  .on(toggleErrorCard, (state, errorCardData) => {
    return initialState.copy({
      ...state,
      errorCard: {
        errorApi: errorCardData.api,
        errorCardVisible: errorCardData.flag,
      },
    });
  });
